module.exports = __webpack_public_path__ + "img/7_77.a8116a58.png";